import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from '../entities/types/SingleEntityState';
import { FAILURE_PRODUCTS, REQUEST_PRODUCTS, SUCCESS_PRODUCTS } from './actions';

export function productsReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_PRODUCTS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_PRODUCTS:
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        case FAILURE_PRODUCTS:
            return _.assign({}, state, {
                isFetching: false,
                error: action.error,
            });
        default:
            return state;
    }
}
